import { Router } from "@remix-run/router";
import { spawn } from "redux-saga/effects";

import appSaga from "./app/app.saga";
import crudSaga from "./crud/crud.saga";
import featuresSaga from "./features/featuresSaga";
import queriesSaga from "./queries/queries.saga";
import redirectionSaga from "./redirection/redirection.saga";

export interface Context {
  router: Router;
}

// https://redux-saga.js.org/docs/advanced/RootSaga/
export default function* rootSaga(context: Context) {
  yield spawn(appSaga);
  yield spawn(crudSaga);
  yield spawn(featuresSaga);
  yield spawn(redirectionSaga, context);
  yield spawn(queriesSaga);
}
